var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_4277)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C10.0118 5 8.4 6.61177 8.4 8.6V10.4H7.8C6.80589 10.4 6 11.2059 6 12.2V16.4C6 17.3941 6.80589 18.2 7.8 18.2H16.2C17.1941 18.2 18 17.3941 18 16.4V12.2C18 11.2059 17.1941 10.4 16.2 10.4H9.6V8.6C9.6 7.27452 10.6745 6.2 12 6.2C13.3255 6.2 14.4 7.27452 14.4 8.6C14.4 8.93137 14.6686 9.2 15 9.2C15.3314 9.2 15.6 8.93137 15.6 8.6C15.6 6.61177 13.9882 5 12 5ZM7.2 12.2C7.2 11.8686 7.46863 11.6 7.8 11.6H16.2C16.5314 11.6 16.8 11.8686 16.8 12.2V16.4C16.8 16.7314 16.5314 17 16.2 17H7.8C7.46863 17 7.2 16.7314 7.2 16.4V12.2Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_4277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlock);
export default __webpack_public_path__ + "static/media/icon-unlock.c8efc4b8168272f68889dbab162e3a5b.svg";
export { ForwardRef as ReactComponent };